import React from 'react'
import './LoadingTiendas.css'
import SwiperCore, { Navigation, Pagination, Autoplay } from 'swiper/core';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper-bundle.css';
SwiperCore.use([Navigation, Pagination, Autoplay]);
export default function LoadingTiendas() {
    return (
        <div className='loadingContain'>

            <Swiper
                effect={'coverflow'}
                grabCursor={true}
                slidesPerView={'auto'}
                className='cardsLoading'
            >

                <SwiperSlide className='cardLoadingTienda' >

                </SwiperSlide>
                <SwiperSlide className='cardLoadingTienda' >

                </SwiperSlide>

                <SwiperSlide className='cardLoadingTienda' >

                </SwiperSlide>
                <SwiperSlide className='cardLoadingTienda' >

                </SwiperSlide>
                <SwiperSlide className='cardLoadingTienda' >

                </SwiperSlide>

            </Swiper>


        </div>
    )
}
